import { QueryClient } from '@tanstack/react-query';

const STALE_TIMES = {
  REALTIME: 0,
  SHORT: 1000 * 60,
  MEDIUM: 1000 * 60 * 5,
  LONG: 1000 * 60 * 30,
  IMMUTABLE: Infinity,
} as const;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIMES.MEDIUM,
      gcTime: 1000 * 60 * 60,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export { STALE_TIMES };
